/* canvas-rooms.js · Elaramo Design
   Laat het canvas van de klant in echte ruimtes zien (woonkamer, slaapkamer, werkplek, hal), op ware schaal,
   met meubels erbij zodat je de grootte goed kunt inschatten. Wordt gebruikt door canvas-configurator.js.
   ElaramoRooms.mount(laag, { getImage, getSize, getDepth }) geeft { setRoom(i), setActive(aan) } terug. */
(function () {
  if (window.ElaramoRooms) return;

  var NAMES = ['Woonkamer', 'Slaapkamer', 'Werkplek', 'Hal', 'Tuin'];
  var REFS = ['Bank · 220 cm breed', 'Bed · 160 cm breed', 'Bureau · 140 cm breed', 'Dressoir · 160 cm breed', 'Schutting · 230 cm hoog'];

  function mount(layer, opts) {
    var api = { ready: false, room: 0, active: false };
    var pending = { room: 0, active: false };
    api.setRoom = function (i) { pending.room = i; if (api.ready) goRoom(i); };
    api.setActive = function (on) { pending.active = on; if (api.ready) setActive(on); };

    // ---------- DOM: canvas, maatlijnen en labels
    layer.innerHTML =
      '<canvas class="ecr-gl"></canvas><canvas class="ecr-snap" aria-hidden="true" style="position:absolute;inset:0;width:100%;height:100%;pointer-events:none;opacity:0"></canvas>' +
      '<svg class="ecr-dims" aria-hidden="true"><path class="ecr-dim-h" d=""/><path class="ecr-dim-v" d=""/></svg>' +
      '<div class="ecr-lbl ecr-lbl-h" aria-hidden="true"></div><div class="ecr-lbl ecr-lbl-v" aria-hidden="true"></div>' +
      '<div class="ecr-ref" aria-hidden="true"></div>';
    var snap = layer.querySelector('.ecr-snap');
    var cvs = layer.querySelector('.ecr-gl'), dimH = layer.querySelector('.ecr-dim-h'), dimV = layer.querySelector('.ecr-dim-v');
    var lblH = layer.querySelector('.ecr-lbl-h'), lblV = layer.querySelector('.ecr-lbl-v'), refEl = layer.querySelector('.ecr-ref');

    var renderer, scene, camera, T, raf = null, visible = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = window.matchMedia && window.matchMedia('(max-width: 900px)').matches;

    function build() {
      T = window.THREE;
      try { renderer = new T.WebGLRenderer({ canvas: cvs, antialias: true }); }
      catch (err) { layer.classList.add('ecr-fail'); return; }
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, mobile ? 1.75 : 2));
      renderer.outputEncoding = T.sRGBEncoding;
      renderer.toneMapping = T.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 0.92;
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = T.PCFSoftShadowMap;

      scene = new T.Scene();
      scene.background = new T.Color(0xe9e3d9).convertSRGBToLinear();
      camera = new T.PerspectiveCamera(FOV, 1, 0.3, 40);

      scene.add(new T.HemisphereLight(0xfff6ea, 0xa8977d, 0.5));
      sun = new T.DirectionalLight(0xffeed6, 1.45);
      sun.castShadow = true;
      sun.shadow.mapSize.set(mobile ? 1024 : 2048, mobile ? 1024 : 2048);
      var sc = sun.shadow.camera; sc.left = -3.4; sc.right = 3.4; sc.top = 3.4; sc.bottom = -1.2; sc.near = 0.5; sc.far = 14;
      sun.shadow.bias = -0.0004; sun.shadow.normalBias = 0.02;
      scene.add(sun); scene.add(sun.target);
      fill = new T.DirectionalLight(0xe6eeff, 0.28); scene.add(fill); scene.add(fill.target);

      buildRooms();
      buildArt();
      api.ready = true;
      resize();
      if (window.ResizeObserver) new ResizeObserver(resize).observe(layer);
      window.addEventListener('resize', resize);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; schedule(); }).observe(layer);
      document.addEventListener('visibilitychange', schedule);
      layer.addEventListener('pointermove', function (e) {
        var r = layer.getBoundingClientRect();
        mx = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width) * 2 - 1));
        my = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height) * 2 - 1));
      });
      layer.addEventListener('pointerleave', function () { mx = 0; my = 0; });
      goRoom(pending.room, true);
      setActive(pending.active);
    }

    // ---------- bouwstenen (zelfde stijl als de hero)
    var FOV = 24, TAN = Math.tan(FOV / 2 * Math.PI / 180), sun, fill;
    function col(hex) { return new T.Color(hex).convertSRGBToLinear(); }
    function mat(hex, rough, extra) {
      var m = new T.MeshStandardMaterial({ color: col(hex), roughness: rough == null ? 0.9 : rough, metalness: 0 });
      if (extra) for (var k in extra) m[k] = extra[k];
      return m;
    }
    function shade(m) { m.castShadow = true; m.receiveShadow = true; return m; }
    var rbCache = {};
    function rbox(w, h, d, b, m) {
      b = Math.min(b || 0.02, w / 2, h / 2, d / 2) * 0.999;
      var key = [w, h, d, b].join('|');
      if (!rbCache[key]) {
        var seg = 7, g = new T.BoxGeometry(1, 1, 1, seg, seg, seg), pos = g.attributes.position, nor = g.attributes.normal;
        var half = 0.5 / seg, bx = w / 2 - b, by = h / 2 - b, bz = d / 2 - b, v = new T.Vector3(), n = new T.Vector3();
        for (var i = 0; i < pos.count; i++) {
          v.fromBufferAttribute(pos, i);
          n.set(v.x - Math.sign(v.x) * half, v.y - Math.sign(v.y) * half, v.z - Math.sign(v.z) * half).normalize();
          pos.setXYZ(i, bx * Math.sign(v.x) + n.x * b, by * Math.sign(v.y) + n.y * b, bz * Math.sign(v.z) + n.z * b);
          nor.setXYZ(i, n.x, n.y, n.z);
        }
        rbCache[key] = g;
      }
      return shade(new T.Mesh(rbCache[key], m));
    }
    function cyl(rt, rb, h, m, seg) { return shade(new T.Mesh(new T.CylinderGeometry(rt, rb, h, seg || 28), m)); }
    function put(parent, mesh, x, y, z, rx, ry, rz) {
      mesh.position.set(x, y, z);
      if (rx || ry || rz) mesh.rotation.set(rx || 0, ry || 0, rz || 0);
      parent.add(mesh); return mesh;
    }
    function floorTex(base) {
      var c = document.createElement('canvas'); c.width = 512; c.height = 512;
      var x = c.getContext('2d'); x.fillStyle = base; x.fillRect(0, 0, 512, 512);
      for (var r = 0; r < 8; r++) {
        var off = (r % 2) * 180 + (r * 53) % 90;
        for (var k = -1; k < 3; k++) {
          x.fillStyle = 'rgba(' + (r % 3 === 0 ? '255,255,255,0.05' : '60,40,20,0.045') + ')';
          x.fillRect(k * 300 + off, r * 64, 300, 64);
          x.fillStyle = 'rgba(70,50,30,0.16)'; x.fillRect(k * 300 + off, r * 64, 2, 64);
        }
        x.fillStyle = 'rgba(70,50,30,0.14)'; x.fillRect(0, r * 64, 512, 1.5);
      }
      var tex = new T.CanvasTexture(c);
      tex.encoding = T.sRGBEncoding; tex.wrapS = tex.wrapT = T.RepeatWrapping; tex.repeat.set(4.5, 3.6);
      tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
      return tex;
    }
    // zacht zonlicht door een raam op de muur
    var sunTex = null, patches = [];
    function sunPatch() {
      if (sunTex) return sunTex;
      var c = document.createElement('canvas'); c.width = c.height = 512;
      var x = c.getContext('2d');
      try { x.filter = 'blur(10px)'; } catch (err) {}
      x.setTransform(1, 0.12, -0.42, 1, 190, 40);
      x.fillStyle = 'rgba(255,236,205,1)';
      [[0, 0], [1, 0], [0, 1], [1, 1]].forEach(function (p) { x.fillRect(40 + p[0] * 118, 40 + p[1] * 170, 106, 158); });
      sunTex = new T.CanvasTexture(c); sunTex.encoding = T.sRGBEncoding;
      return sunTex;
    }
    function shell(g, wallHex, floorHex) {
      var wall = put(g, new T.Mesh(new T.PlaneGeometry(7, 3.6), mat(wallHex, 0.96)), 0, 1.8, 0);
      wall.receiveShadow = true;
      var fl = put(g, new T.Mesh(new T.PlaneGeometry(7, 6.5), new T.MeshStandardMaterial({ map: floorTex(floorHex), roughness: 0.78 })), 0, 0, 3.25, -Math.PI / 2);
      fl.receiveShadow = true;
      put(g, rbox(7, 0.08, 0.016, 0.004, mat(wallHex, 0.8)), 0, 0.04, 0.008);
      // raamlicht alleen in de woonkamer
      if (wallHex !== '#e8dccb') return;
      var pm = new T.Mesh(new T.PlaneGeometry(2.1, 2.1), new T.MeshBasicMaterial({ map: sunPatch(), transparent: true, opacity: 0.12, blending: T.AdditiveBlending, depthWrite: false, toneMapped: false }));
      pm.position.set(-2.05, 1.7, 0.003); g.add(pm); patches.push(pm);
    }
    function plant(g, x, z, s, potHex) {
      var leaf = mat('#7d9370', 0.85, { flatShading: true });
      put(g, cyl(0.16 * s, 0.12 * s, 0.36 * s, mat(potHex || '#d8d1c6', 0.8)), x, 0.18 * s, z);
      var pts = [[0, 0.62, 0, 0.2], [-0.13, 0.82, 0.04, 0.17], [0.12, 0.92, -0.03, 0.18], [-0.04, 1.08, 0.06, 0.16], [0.08, 1.22, 0.02, 0.14], [-0.1, 1.3, -0.04, 0.12]];
      pts.forEach(function (p) { put(g, shade(new T.Mesh(new T.IcosahedronGeometry(p[3] * s, 1), leaf)), x + p[0] * s, p[1] * s, z + p[2] * s); });
      put(g, cyl(0.012 * s, 0.016 * s, 0.9 * s, mat('#6b5a45')), x, 0.75 * s, z);
    }
    function lampShade(hex) { return mat(hex || '#f4eee4', 0.9, { emissive: col('#ffdcae'), emissiveIntensity: 0.22 }); }
    // ---------- texturen voor de tuin
    function cvTex(w, h, draw, rx, ry) {
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      draw(c.getContext('2d'), w, h);
      var t = new T.CanvasTexture(c); t.encoding = T.sRGBEncoding;
      if (rx) { t.wrapS = t.wrapT = T.RepeatWrapping; t.repeat.set(rx, ry); }
      t.anisotropy = renderer.capabilities.getMaxAnisotropy();
      return t;
    }
    function skyTex() {
      return cvTex(512, 256, function (x, w, h) {
        var g = x.createLinearGradient(0, 0, 0, h); g.addColorStop(0, '#a8c6e2'); g.addColorStop(0.75, '#e4ece9'); g.addColorStop(1, '#f1f1ea');
        x.fillStyle = g; x.fillRect(0, 0, w, h);
        for (var i = 0; i < 26; i++) {
          var cx = Math.random() * w, cy = 20 + Math.random() * h * 0.45, r = 18 + Math.random() * 38;
          var b = x.createRadialGradient(cx, cy, 0, cx, cy, r); b.addColorStop(0, 'rgba(255,255,255,0.55)'); b.addColorStop(1, 'rgba(255,255,255,0)');
          x.fillStyle = b; x.fillRect(cx - r, cy - r, r * 2, r * 2);
        }
      });
    }
    function fenceTex() {
      return cvTex(512, 512, function (x, w, h) {
        for (var i = 0; i < 8; i++) {
          var l = 46 + (i * 37) % 14;
          x.fillStyle = 'hsl(28,' + (30 + (i * 13) % 9) + '%,' + l + '%)'; x.fillRect(i * 64, 0, 64, h);
          for (var k = 0; k < 7; k++) { x.fillStyle = 'rgba(70,45,25,' + (0.05 + (k % 3) * 0.03) + ')'; x.fillRect(i * 64 + 6 + k * 8 + ((i * k) % 5), 0, 1.5, h); }
          x.fillStyle = 'rgba(40,25,15,0.55)'; x.fillRect(i * 64, 0, 3, h);
        }
      }, 7.3, 1);
    }
    function grassTex() {
      return cvTex(256, 256, function (x, w, h) {
        x.fillStyle = '#7d985a'; x.fillRect(0, 0, w, h);
        for (var i = 0; i < 2600; i++) {
          var gx = Math.random() * w, gy = Math.random() * h, l = 28 + Math.random() * 22;
          x.strokeStyle = 'hsl(' + (80 + Math.random() * 20) + ',35%,' + l + '%)'; x.lineWidth = 1;
          x.beginPath(); x.moveTo(gx, gy); x.lineTo(gx + (Math.random() - 0.5) * 3, gy - 3 - Math.random() * 4); x.stroke();
        }
      }, 14, 13);
    }
    function tileTex() {
      return cvTex(512, 512, function (x, w, h) {
        x.fillStyle = '#b9b1a2'; x.fillRect(0, 0, w, h);
        for (var r = 0; r < 4; r++) for (var c = 0; c < 4; c++) {
          var l = 80 + ((r * 7 + c * 5) % 6);
          x.fillStyle = 'hsl(38,14%,' + l + '%)'; x.fillRect(c * 128 + 3, r * 128 + 3, 122, 122);
        }
      }, 7, 2.5);
    }

    // ---------- kamers (meters: muur op z=0, vloer op y=0); bottom = hoogte onderkant canvas
    var ROOMS = [
      { bottom: 1.07, spanW: 3.7, build: function (g) {
        shell(g, '#e8dccb', '#c9ad88');
        var sofa = mat('#94a387', 0.95), wood = mat('#6b5440', 0.7);
        put(g, rbox(2.5, 0.014, 1.6, 0.006, mat('#ddd0bb', 1)), 0, 0.007, 1.0);
        [[-1, 0.12], [1, 0.12], [-1, 0.82], [1, 0.82]].forEach(function (p) { put(g, cyl(0.022, 0.018, 0.08, wood), p[0], 0.04, p[1]); });
        put(g, rbox(2.2, 0.22, 0.9, 0.04, sofa), 0, 0.19, 0.47);
        put(g, rbox(2.2, 0.66, 0.17, 0.05, sofa), 0, 0.41, 0.1);
        put(g, rbox(0.18, 0.5, 0.9, 0.06, sofa), -1.01, 0.33, 0.47);
        put(g, rbox(0.18, 0.5, 0.9, 0.06, sofa), 1.01, 0.33, 0.47);
        [-0.61, 0, 0.61].forEach(function (x) {
          put(g, rbox(0.6, 0.16, 0.66, 0.06, sofa), x, 0.38, 0.57);
          put(g, rbox(0.6, 0.4, 0.17, 0.07, sofa), x, 0.6, 0.26, -0.14);
        });
        put(g, rbox(0.42, 0.38, 0.12, 0.06, mat('#c98d62')), -0.68, 0.62, 0.4, -0.18, 0, 0.12);
        put(g, rbox(0.36, 0.34, 0.11, 0.055, mat('#e9e1d2')), 0.72, 0.6, 0.4, -0.18, 0, -0.1);
        var dark = mat('#3d3935', 0.6);
        put(g, cyl(0.24, 0.24, 0.03, mat('#b8946e', 0.7)), 1.48, 0.55, 0.36);
        put(g, cyl(0.025, 0.025, 0.52, dark), 1.48, 0.28, 0.36);
        put(g, cyl(0.15, 0.17, 0.02, dark), 1.48, 0.01, 0.36);
        put(g, cyl(0.045, 0.065, 0.26, mat('#d9cfc0', 0.6)), 1.48, 0.7, 0.32);
        put(g, cyl(0.11, 0.16, 0.19, lampShade()), 1.48, 0.92, 0.32);
        plant(g, -1.55, 0.32, 1.05);
      } },
      { bottom: 1.33, spanW: 3.4, build: function (g) {
        shell(g, '#d7dcd9', '#cdb595');
        var linen = mat('#bfa98c', 0.98), white = mat('#f5f2ec', 1), oak = mat('#b28d68', 0.75);
        put(g, rbox(1.8, 1.05, 0.1, 0.04, linen), 0, 0.525, 0.06);
        put(g, rbox(1.7, 0.28, 2.05, 0.04, linen), 0, 0.17, 1.14);
        put(g, rbox(1.6, 0.22, 1.98, 0.06, white), 0, 0.42, 1.15);
        // dekbed valt zacht over de randen van het matras, met een omgeslagen rand bij het hoofdeinde
        put(g, rbox(1.74, 0.31, 1.4, 0.07, mat('#eeeae2', 1)), 0, 0.455, 1.45);
        put(g, rbox(1.76, 0.05, 0.2, 0.025, mat('#f7f4ef', 1)), 0, 0.615, 0.84);
        // plaid over het voeteneind, valt over de rand naar beneden
        put(g, rbox(1.8, 0.21, 0.44, 0.05, mat('#c4977a', 0.95)), 0, 0.525, 1.955);
        [-0.39, 0.39].forEach(function (x) { put(g, rbox(0.62, 0.16, 0.38, 0.075, mat('#faf8f4', 1)), x, 0.63, 0.36, -0.4); });
        [-1.2, 1.2].forEach(function (x) {
          put(g, rbox(0.45, 0.5, 0.4, 0.02, oak), x, 0.25, 0.21);
          put(g, rbox(0.37, 0.006, 0.006, 0.002, mat('#8a6a4c')), x, 0.3, 0.413);
          put(g, shade(new T.Mesh(new T.SphereGeometry(0.085, 24, 16), mat('#d8cbb8', 0.5))), x, 0.585, 0.2);
          put(g, cyl(0.1, 0.13, 0.17, lampShade()), x, 0.75, 0.2);
        });
      } },
      { bottom: 1.17, spanW: 3.0, build: function (g) {
        shell(g, '#dde2d3', '#c9ae8a');
        var oak = mat('#bc9a74', 0.7), black = mat('#2f2d2b', 0.55);
        put(g, rbox(1.4, 0.035, 0.7, 0.012, oak), 0, 0.74, 0.37);
        [[-0.66, 0.08], [0.66, 0.08], [-0.66, 0.66], [0.66, 0.66]].forEach(function (p) { put(g, rbox(0.035, 0.72, 0.035, 0.008, black), p[0], 0.36, p[1]); });
        var alu = mat('#c9cbcd', 0.45);
        put(g, rbox(0.33, 0.014, 0.23, 0.004, alu), 0.02, 0.765, 0.46);
        put(g, rbox(0.33, 0.22, 0.008, 0.003, alu), 0.02, 0.87, 0.335, -0.22);
        put(g, cyl(0.04, 0.04, 0.09, mat('#f3eee6', 0.6)), 0.24, 0.803, 0.5);
        put(g, rbox(0.25, 0.035, 0.18, 0.004, mat('#c98d62')), 0.48, 0.775, 0.3);
        put(g, rbox(0.23, 0.03, 0.17, 0.004, mat('#2c3e50')), 0.48, 0.808, 0.3, 0, 0.12);
        plant(g, 0.5, 0.18, 0.38, '#efe9df');
        var seat = mat('#c98d62', 0.95), chair = new T.Group();
        put(chair, rbox(0.5, 0.07, 0.48, 0.03, seat), 0, 0.47, 0);
        put(chair, rbox(0.46, 0.42, 0.05, 0.025, seat), 0, 0.77, 0.24, 0.1);
        put(chair, cyl(0.022, 0.022, 0.4, black), 0, 0.25, 0);
        put(chair, cyl(0.2, 0.22, 0.025, black), 0, 0.03, 0);
        put(g, chair, -0.5, 0, 0.85, 0, 0.55);
        put(g, cyl(0.13, 0.13, 0.022, black), 1.2, 0.011, 0.3);
        put(g, cyl(0.011, 0.011, 1.5, black), 1.2, 0.76, 0.3);
        put(g, cyl(0.1, 0.18, 0.2, lampShade('#efe8dc')), 1.2, 1.56, 0.3);
      } },
      { bottom: 1.09, spanW: 3.1, build: function (g) {
        shell(g, '#ead9c6', '#c2a37f');
        var walnut = mat('#8a6a4f', 0.7), dark = mat('#2f2b27', 0.6);
        put(g, rbox(1.6, 0.58, 0.44, 0.02, walnut), 0, 0.46, 0.24);
        [-0.267, 0.267].forEach(function (x) { put(g, rbox(0.006, 0.52, 0.006, 0.002, mat('#5e4634')), x, 0.46, 0.462); });
        [[-0.72, 0.08], [0.72, 0.08], [-0.72, 0.4], [0.72, 0.4]].forEach(function (p) { put(g, cyl(0.017, 0.013, 0.17, dark), p[0], 0.085, p[1]); });
        put(g, cyl(0.055, 0.09, 0.32, mat('#ebe5da', 0.5)), -0.66, 0.91, 0.24);
        var stem = mat('#6d5c47');
        [[-0.34, 0.1], [-0.17, -0.05], [-0.02, 0.08]].forEach(function (r) {
          put(g, cyl(0.005, 0.006, 0.62, stem, 6), -0.66 + Math.sin(r[0]) * 0.3, 1.36, 0.24 + r[1] * 0.3, r[1], 0, -r[0]);
          put(g, shade(new T.Mesh(new T.IcosahedronGeometry(0.035, 0), mat('#94a385', 0.9, { flatShading: true }))), -0.66 + Math.sin(r[0]) * 0.6, 1.66, 0.24 + r[1] * 0.6);
        });
        put(g, cyl(0.15, 0.08, 0.07, mat('#c98d62', 0.6)), 0.45, 0.785, 0.24);
        put(g, rbox(0.27, 0.04, 0.2, 0.004, mat('#e5dccd')), 0.05, 0.77, 0.24);
        put(g, rbox(0.24, 0.035, 0.18, 0.004, mat('#2c3e50')), 0.05, 0.808, 0.24, 0, -0.1);
        plant(g, 1.3, 0.3, 0.95, '#cfc6b8');
      } },
      { bottom: 0.98, spanW: 3.6, maxTop: 2.12, minBottom: 0.03, build: function (g) {
        // tuin: lucht en boomkruinen achter een houten schutting
        var sky = new T.Mesh(new T.PlaneGeometry(26, 12), new T.MeshBasicMaterial({ map: skyTex(), toneMapped: false }));
        sky.position.set(0, 4.4, -4.5); g.add(sky);
        var leafA = mat('#6f8a5e', 0.9, { flatShading: true }), leafB = mat('#86a06f', 0.9, { flatShading: true });
        [[-2.7, 2.7, -1.2, 0.75], [-1.75, 2.95, -1.7, 0.95], [-0.55, 2.55, -1.0, 0.55], [0.75, 2.85, -1.6, 0.9], [1.95, 2.6, -1.1, 0.7], [3.0, 3.0, -1.8, 1.0]].forEach(function (t, i) {
          put(g, shade(new T.Mesh(new T.IcosahedronGeometry(t[3], 1), i % 2 ? leafA : leafB)), t[0], t[1], t[2]);
        });
        var fence = put(g, new T.Mesh(new T.PlaneGeometry(7, 2.3), new T.MeshStandardMaterial({ map: fenceTex(), roughness: 0.85 })), 0, 1.15, 0);
        fence.receiveShadow = true;
        put(g, rbox(7, 0.06, 0.05, 0.01, mat('#7a5c43', 0.8)), 0, 2.3, 0.025);
        // gras met een terras van natuursteen
        var grass = put(g, new T.Mesh(new T.PlaneGeometry(7, 6.5), new T.MeshStandardMaterial({ map: grassTex(), roughness: 1 })), 0, -0.002, 3.25, -Math.PI / 2);
        grass.receiveShadow = true;
        var pat = put(g, new T.Mesh(new T.PlaneGeometry(4.2, 1.5), new T.MeshStandardMaterial({ map: tileTex(), roughness: 0.9 })), 0, 0.004, 0.75, -Math.PI / 2);
        pat.receiveShadow = true;
        // teakhouten tuinbank
        var teak = mat('#a87b52', 0.75), iron = mat('#2f2d2b', 0.5);
        // de bank staat in een eigen groep: bij een heel hoog canvas verdwijnt hij, zodat het canvas lager kan hangen
        var bench = new T.Group(); g.add(bench); this.bench = bench; this.benchMat = teak;
        [0, 1, 2, 3].forEach(function (k) { put(bench, rbox(1.5, 0.03, 0.09, 0.008, teak), 0, 0.45, 0.2 + k * 0.11); });
        [0, 1, 2].forEach(function (k) { put(bench, rbox(1.5, 0.08, 0.025, 0.008, teak), 0, 0.6 + k * 0.12, 0.13 - k * 0.015, -0.12); });
        [[-0.7, 0.18], [0.7, 0.18], [-0.7, 0.55], [0.7, 0.55]].forEach(function (q) { put(bench, rbox(0.05, 0.45, 0.05, 0.01, teak), q[0], 0.225, q[1]); });
        [-0.74, 0.74].forEach(function (x) { put(bench, rbox(0.05, 0.05, 0.5, 0.01, teak), x, 0.64, 0.37); });
        // plantenbakken met buxusbollen
        [-1.45, 1.45].forEach(function (x) {
          put(g, rbox(0.42, 0.5, 0.42, 0.03, mat('#3b3a38', 0.7)), x, 0.25, 0.3);
          put(g, shade(new T.Mesh(new T.IcosahedronGeometry(0.27, 1), leafB)), x, 0.72, 0.3);
        });
        // lantaarn
        put(g, rbox(0.17, 0.03, 0.17, 0.008, iron), 2.15, 0.015, 0.45);
        put(g, rbox(0.13, 0.24, 0.13, 0.01, mat('#fff4dc', 0.6, { emissive: col('#ffcf8a'), emissiveIntensity: 0.55 })), 2.15, 0.15, 0.45);
        put(g, rbox(0.19, 0.04, 0.19, 0.01, iron), 2.15, 0.29, 0.45);
        plant(g, -2.3, 0.4, 0.9, '#b9a58e');
      } }
    ];
    var roomGroups = [], GAP = 7, step = 0;
    function buildRooms() {
      roomGroups = ROOMS.map(function (r) { var g = new T.Group(); r.build(g); g.visible = false; scene.add(g); return g; });
    }
    // licht (en schaduw) staat stil tijdens een overgang; het dekt dan beide kamers, zodat schaduwen niet verspringen
    function aimLights(x, span) {
      span = span || 0;
      sun.position.set(x - 2.4, 4.4, 3.6); sun.target.position.set(x, 0.9, 0.6);
      fill.position.set(x + 3.5, 2.2, 4.5); fill.target.position.set(x, 1, 0);
      var sc = sun.shadow.camera; sc.left = -3.4 - span; sc.right = 3.4 + span; sc.updateProjectionMatrix();
    }

    // ---------- het canvas van de klant
    var art, mesh = null, built = null, blob, blobMat, tex = null, texUrl = null, loadingUrl = null;
    var hideMat;
    function buildArt() {
      art = new T.Group(); scene.add(art);
      hideMat = new T.MeshBasicMaterial({ visible: false });
      var bc = document.createElement('canvas'); bc.width = bc.height = 128;
      var bx = bc.getContext('2d'), bg = bx.createRadialGradient(64, 64, 6, 64, 64, 64);
      bg.addColorStop(0, 'rgba(45,32,20,0.42)'); bg.addColorStop(0.5, 'rgba(45,32,20,0.16)'); bg.addColorStop(1, 'rgba(45,32,20,0)');
      bx.fillStyle = bg; bx.fillRect(0, 0, 128, 128);
      blobMat = new T.MeshBasicMaterial({ map: new T.CanvasTexture(bc), transparent: true, depthWrite: false });
      blob = new T.Mesh(new T.PlaneGeometry(1, 1), blobMat); blob.renderOrder = 1; scene.add(blob);
    }
    function buildMesh(w, h, d) {
      if (mesh) { art.remove(mesh); mesh.traverse(function (o) { if (o.geometry) o.geometry.dispose(); if (o.material && o.material !== hideMat) (Array.isArray(o.material) ? o.material : [o.material]).forEach(function (m) { if (m !== hideMat) m.dispose(); }); }); mesh = null; }
      built = { w: w, h: h, d: d, lay: layKey() };
      var tri = opts.getTri ? opts.getTri() : null;
      if (tri && tex) { mesh = buildTri(w, h, d, tri); art.add(mesh); return; }
      var W = w / 100, H = h / 100, D = d / 100;
      var geo = new T.BoxGeometry(W, H, D), front, side;
      if (tex) {
        // voorkant: hele foto (bijgesneden als de verhouding net anders is); zijkanten: de rand van de foto
        var iar = tex.image ? tex.image.width / tex.image.height : W / H, car = W / H, ru = 1, rv = 1;
        if (iar > car) ru = car / iar; else if (iar < car) rv = iar / car;
        var u0 = (1 - ru) / 2, u1 = 1 - u0, v0 = (1 - rv) / 2, v1 = 1 - v0, eu = Math.min(0.04, D / W) * ru, ev = Math.min(0.04, D / H) * rv;
        var uv = geo.attributes.uv;
        var faces = [[u1 - eu, v0, u1, v1], [u0, v0, u0 + eu, v1], [u0, v1 - ev, u1, v1], [u0, v0, u1, v0 + ev], [u0, v0, u1, v1], [u0, v0, u1, v1]];
        for (var f = 0; f < 6; f++) {
          var r = faces[f], b = f * 4;
          uv.setXY(b, r[0], r[3]); uv.setXY(b + 1, r[2], r[3]); uv.setXY(b + 2, r[0], r[1]); uv.setXY(b + 3, r[2], r[1]);
        }
        uv.needsUpdate = true;
        front = new T.MeshStandardMaterial({ map: tex, roughness: 0.86, metalness: 0 }); front.toneMapped = false; // zelfde kleuren als in de 3D-studio (die rendert zonder tone mapping)
        side = new T.MeshStandardMaterial({ map: tex, roughness: 0.9, metalness: 0, color: col('#d6d0c6') });
      } else {
        front = new T.MeshStandardMaterial({ color: col('#f6f3ee'), roughness: 0.95 });
        side = new T.MeshStandardMaterial({ color: col('#e0d9cc'), roughness: 0.95 });
      }
      mesh = new T.Mesh(geo, [side, side, side, side, front, hideMat]);
      mesh.castShadow = true; mesh.receiveShadow = true;
      art.add(mesh);
    }
    // drieluik: drie panelen naast elkaar, elk met het eigen stuk van de foto
    function buildTri(w, h, d, tri) {
      var g = new T.Group(), e = d, TT = w + 2 * e, TH = h + 2 * e, pw = tri.pw, gap = tri.gap, ph = tri.ph || h, cols = tri.cols || 3, rows = tri.rows || 1;
      var front = new T.MeshStandardMaterial({ map: tex, roughness: 0.86, metalness: 0 }); front.toneMapped = false;
      var side = new T.MeshStandardMaterial({ map: tex, roughness: 0.9, metalness: 0, color: col('#d6d0c6') });
      function U(x) { return x / TT; } function V(y) { return 1 - y / TH; }
      for (var n = 0; n < cols * rows; n++) {
        var i = n % cols, rr = Math.floor(n / cols);
        var x0 = e + i * (pw + gap), x1 = x0 + pw, y0 = e + rr * (ph + gap), y1 = y0 + ph;
        var geo = new T.BoxGeometry(pw / 100, ph / 100, d / 100), uv = geo.attributes.uv;
        var faces = [[U(x1), V(y1), U(x1 + d), V(y0)], [U(x0 - d), V(y1), U(x0), V(y0)], [U(x0), V(y0), U(x1), V(y0 - d)], [U(x0), V(y1 + d), U(x1), V(y1)], [U(x0), V(y1), U(x1), V(y0)], [U(x0), V(y1), U(x1), V(y0)]];
        for (var f = 0; f < 6; f++) { var r = faces[f], b = f * 4; uv.setXY(b, r[0], r[3]); uv.setXY(b + 1, r[2], r[3]); uv.setXY(b + 2, r[0], r[1]); uv.setXY(b + 3, r[2], r[1]); }
        uv.needsUpdate = true;
        var m = new T.Mesh(geo, [side, side, side, side, front, hideMat]);
        m.castShadow = true; m.receiveShadow = true; m.position.x = (i - (cols - 1) / 2) * (pw + gap) / 100; m.position.y = ((rows - 1) / 2 - rr) * (ph + gap) / 100;
        g.add(m);
      }
      return g;
    }
    function loadImage(url) {
      if (!url || url === texUrl || url === loadingUrl) return;
      loadingUrl = url;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        if (loadingUrl !== url) return;
        loadingUrl = null;
        var t = new T.Texture(img); t.encoding = T.sRGBEncoding; t.anisotropy = renderer.capabilities.getMaxAnisotropy(); t.needsUpdate = true;
        var old = tex; tex = t; texUrl = url;
        // opnieuw opbouwen op de maat die nu getoond wordt (ook midden in een groei-animatie)
        if (built && !(anim && (anim.type === 'fade' || anim.type === 'slide') && !anim.swapped)) { buildMesh(built.w, built.h, built.d); if (artOp < 1) setArtOpacity(artOp); }
        if (old) old.dispose();
        kick();
      };
      img.onerror = function () { if (loadingUrl === url) loadingUrl = null; };
      img.src = url;
    }

    // ---------- plaats en camera
    function mountPos(k, room, w, h, d) {
      var H = h / 100, bottom = room.bottom;
      // nooit hoger dan het plafond, en in de tuin niet boven de schutting (anders steekt de bovenbalk door het canvas)
      var maxT = room.maxTop || 2.5;
      if (bottom + H > maxT) bottom = Math.max(room.minBottom != null ? room.minBottom : room.bottom - 0.1, maxT - H);
      return new T.Vector3(k * GAP, bottom + H / 2, d / 200 + 0.012);
    }
    var aspect = 1;
    function camFor(k, room, w, h, pos) {
      // vaste camera (homepage): altijd hetzelfde beeld, ongeacht de vorm van het canvas
      if (opts.camSize) { w = opts.camSize[0]; h = opts.camSize[1]; pos = mountPos(k, room, w, h, 2); }
      var top = Math.max(pos.y + h / 200 + (mobile ? 0.42 : 0.32), 2.1), bot = -0.3;
      var spanH = top - bot, spanW = Math.max(room.spanW, w / 100 * 1.5);
      var dd = Math.max(spanH / 2 / TAN, spanW / 2 / (TAN * aspect)) * 1.03;
      var cy = (top + bot) / 2;
      return { x: k * GAP, y: cy + 0.3, z: dd, ty: cy };
    }
    function resize() {
      if (!renderer) return;
      var w = layer.clientWidth, h = layer.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h, false);
      aspect = w / h; camera.aspect = aspect; camera.updateProjectionMatrix();
      if (cur) { cur.cam = camFor(cur.k, ROOMS[cur.room], cur.w, cur.h, cur.pos); if (!anim) copyCam(cam, cur.cam); }
      kick();
    }
    function copyCam(a, b) { a.x = b.x; a.y = b.y; a.z = b.z; a.ty = b.ty; }
    // camera vlak voor het canvas: zo ziet het eruit als in de 3D-studio (begin- en eindpunt van de overgang)
    function closeCam(c) {
      var W = c.w / 100, H = c.h / 100;
      var dd = Math.max(W * 1.22 / 2 / (TAN * aspect), H * 1.45 / 2 / TAN, 0.5);
      return { x: c.pos.x, y: c.pos.y + 0.015, z: c.pos.z + dd, ty: c.pos.y };
    }

    // ---------- toestand en animaties
    var cur = null, anim = null, cam = { x: 0, y: 1.4, z: 6, ty: 1.1 }, queued = null, settleT = 0;
    function want() {
      var s = opts.getSize ? opts.getSize() : [60, 40];
      return { w: s[0], h: s[1], d: opts.getDepth ? opts.getDepth() : 2 };
    }
    // vorm: één canvas of twee-/drie-/vierluik
    function layKey() { var t = opts.getTri ? opts.getTri() : null; return t ? (t.cols || 3) + "x" + (t.rows || 1) : "one"; }
    var artOp = 1;
    function setArtOpacity(o) {
      artOp = o;
      if (mesh) mesh.traverse(function (x) {
        if (!x.isMesh) return;
        (Array.isArray(x.material) ? x.material : [x.material]).forEach(function (m) {
          if (!m || m === hideMat) return;
          var tr = o < 1; if (m.transparent !== tr) { m.transparent = tr; m.needsUpdate = true; }
          m.opacity = o; m.depthWrite = o > 0.5;
        });
      });
      if (blobMat) blobMat.opacity = o;
    }
    function place(room, k, wv) {
      var g = roomGroups[room]; g.position.x = k * GAP; g.visible = true;
      var pos = mountPos(k, ROOMS[room], wv.w, wv.h, wv.d);
      return { room: room, k: k, w: wv.w, h: wv.h, d: wv.d, lay: layKey(), pos: pos, cam: camFor(k, ROOMS[room], wv.w, wv.h, pos) };
    }
    function setBlob(c) {
      blob.position.set(c.pos.x + 0.035, c.pos.y - 0.05, 0.004);
      blob.scale.set(c.w / 100 * 1.32 + 0.12, c.h / 100 * 1.32 + 0.12, 1);
    }
    function goRoom(i, first) {
      i = Math.max(0, Math.min(ROOMS.length - 1, i | 0));
      api.room = i;
      if (anim && anim.type === 'outro') anim = null;
      if (anim && (anim.type === 'resize' || anim.type === 'flip')) { queued = i; return; }
      if (cur && cur.room === i && api.active) return;
      var wv = want();
      if (!cur || !api.active) {
        // vanuit de studio meteen in de gekozen kamer beginnen (geen tussenstop in de vorige kamer)
        cur = place(i, cur ? cur.k : 0, wv);
        roomGroups.forEach(function (g, gi) { if (gi !== i) g.visible = false; });
        buildMesh(wv.w, wv.h, wv.d);
        art.position.copy(cur.pos); setBlob(cur);
        copyCam(cam, closeCam(cur));
        anim = { type: 'intro', t0: performance.now(), dur: (reduce || opts.noIntro) ? 1 : 1800, from: Object.assign({}, cam), to: cur, rot: 0 };
        turn(cur, anim.rot);
        aimLights(cur.pos.x); setRef(i); setDims(false); kick();
        return;
      }
      // andere kamer: het huidige beeld vervaagt en schuift weg, de nieuwe kamer glijdt er rustig in.
      // Licht, schaduwen en canvas staan in de nieuwe kamer meteen goed, dus er springt niets.
      var dir = i > cur.room ? 1 : -1;
      snapshot(dir);
      var nx = place(i, 0, { w: cur.w, h: cur.h, d: cur.d });
      roomGroups.forEach(function (g, gi) { g.visible = gi === i; });
      art.position.copy(nx.pos); art.rotation.set(0, 0, 0); art.scale.set(1, 1, 1);
      setBlob(nx); blobMat.opacity = 1; aimLights(nx.pos.x);
      setDims(false); setRef(-1);
      cur = nx;
      var from = { x: nx.cam.x + dir * 0.12, y: nx.cam.y + 0.02, z: nx.cam.z + 0.18, ty: nx.cam.ty };
      copyCam(cam, from);
      anim = { type: 'intro', t0: performance.now(), dur: reduce ? 1 : 1100, from: from, to: nx, soft: true };
      kick();
    }
    function snapshot(dir) {
      if (reduce || !renderer || !snap) return;
      try {
        renderer.render(scene, camera);
        if (snap.width !== cvs.width || snap.height !== cvs.height) { snap.width = cvs.width; snap.height = cvs.height; }
        var x = snap.getContext('2d'); x.clearRect(0, 0, snap.width, snap.height); x.drawImage(cvs, 0, 0);
        // labels van de vorige kamer meteen weg (niet laten nafaden op de verkeerde plek)
        [layer.querySelector('.ecr-dims'), lblH, lblV, refEl].forEach(function (el) { if (!el) return; el.style.transition = 'none'; el.style.opacity = '0'; });
        setTimeout(function () { [layer.querySelector('.ecr-dims'), lblH, lblV, refEl].forEach(function (el) { if (el) { el.style.opacity = ''; el.style.transition = ''; } }); }, 60);
        // als foto's doorvegen: de oude kamer schuift er helemaal uit, de nieuwe er strak naast in (geen overlap)
        [snap, cvs].forEach(function (el) { if (el.getAnimations) el.getAnimations().forEach(function (a) { a.cancel(); }); });
        if (snap.animate) {
          var o = { duration: 760, easing: 'cubic-bezier(.65,0,.25,1)', fill: 'forwards' };
          snap.animate([{ opacity: 1, transform: 'translateX(0)' }, { opacity: 1, transform: 'translateX(' + (-dir * 100) + '%)' }], o);
          cvs.animate([{ transform: 'translateX(' + (dir * 100) + '%)' }, { transform: 'translateX(0)' }], o);
        }
      } catch (err) {}
    }
    function land(c) {
      cur = c;
      if (built && built.lay !== layKey()) buildMesh(c.w, c.h, c.d);
      if (artOp < 1) setArtOpacity(1);
      roomGroups.forEach(function (g, gi) { if (gi !== c.room) g.visible = false; });
      art.position.copy(c.pos); art.rotation.set(0, 0, 0); art.scale.set(1, 1, 1);
      setBlob(c); blobMat.opacity = 1;
      aimLights(c.pos.x);
      copyCam(cam, c.cam);
      settleT = performance.now();
      setRef(c.room); setLabels();
      if (queued != null && queued !== c.room) { var q = queued; queued = null; goRoom(q); }
      queued = null;
    }
    // formaat of dikte veranderd: canvas groeit of krimpt vloeiend, camera schuift mee
    function checkGeometry() {
      if (!cur || anim) return;
      var wv = want();
      var lk = layKey();
      if (cur.lay && lk !== cur.lay) {
        var spd = opts.getSpeed ? +opts.getSpeed() || 0 : 0;
        if (spd > 0 && !reduce) {
          // snelle carrousel (hero): het oude canvas schuift weg, het nieuwe schuift erin
          var ns = place(cur.room, cur.k, wv); ns.cam = cur.cam;
          setDims(false); layer.classList.remove('ecr-ref-on');
          anim = { type: 'slide', t0: performance.now(), dur: spd, fromPos: art.position.clone(), to: ns, dx: 0.7 + wv.w / 100 * 0.8, swapped: false, ease: opts.getEase ? Math.max(0, Math.min(1, +opts.getEase() || 0)) : 1 };
          kick();
          return;
        }
        // andere vorm (bijv. canvas <-> drieluik): het oude canvas vervaagt, daarna komt de nieuwe keuze in beeld
        var nf = place(cur.room, cur.k, wv);
        // camera blijft op dezelfde hoogte; alleen iets in- of uitzoomen zodat alles in beeld blijft
        if (!opts.camSize) (function () {
          var top = Math.max(nf.pos.y + wv.h / 200 + (mobile ? 0.42 : 0.32), 2.1), bot = -0.3, cy = cur.cam.ty;
          var half = Math.max(top - cy, cy - bot), spanW = Math.max(ROOMS[nf.room].spanW, wv.w / 100 * 1.5);
          var dd = Math.max(half / TAN, spanW / 2 / (TAN * aspect)) * 1.03;
          nf.cam = { x: nf.cam.x, y: cur.cam.y, z: dd, ty: cur.cam.ty };
        })();
        setDims(false); layer.classList.remove('ecr-ref-on');
        if (reduce) { buildMesh(wv.w, wv.h, wv.d); land(nf); return; }
        anim = { type: 'fade', t0: performance.now(), fromPos: art.position.clone(), fromCam: Object.assign({}, cam), to: nf, tex0: texUrl, swapped: false };
        return;
      }
      if (wv.w === cur.w && wv.h === cur.h && wv.d === cur.d) return;
      var nx = place(cur.room, cur.k, wv);
      if (!reduce && cur.w !== cur.h && wv.w !== wv.h && (cur.w > cur.h) !== (wv.w > wv.h)) {
        // liggend <-> staand: het canvas draait als een kaart om en komt in de nieuwe stand terug
        setDims(false); layer.classList.remove('ecr-ref-on');
        anim = { type: 'flip', t0: performance.now(), dur: 900, fromPos: art.position.clone(), fromCam: Object.assign({}, cam), fromW: cur.w, fromH: cur.h, to: nx, tex0: texUrl, swapped: false };
        return;
      }
      if (!reduce) {
        // ander formaat: het oude canvas vervaagt, daarna verschijnt het nieuwe formaat (geen zichtbaar uitrekken)
        setDims(false); layer.classList.remove('ecr-ref-on');
        var sameAsp = Math.abs(cur.w / cur.h - wv.w / wv.h) < 0.002;
        anim = { type: 'fade', t0: performance.now(), fromPos: art.position.clone(), fromCam: Object.assign({}, cam), to: nx, tex0: texUrl, swapped: false, go: sameAsp ? performance.now() : 0, maxWait: 700, size: true };
        return;
      }
      buildMesh(wv.w, wv.h, wv.d);
      art.scale.set(cur.w / wv.w, cur.h / wv.h, cur.d / wv.d);
      setDims(false);
      anim = { type: 'resize', t0: performance.now(), dur: reduce ? 1 : 650, fromPos: art.position.clone(), fromCam: Object.assign({}, cam), fromScale: art.scale.clone(), to: nx };
    }

    // ---------- maatlijnen + referentie
    function scr(x, y, z) { var v = new T.Vector3(x, y, z).project(camera); return [(v.x + 1) / 2 * layer.clientWidth, (1 - v.y) / 2 * layer.clientHeight]; }
    function setDims(on) { layer.classList.toggle('ecr-dims-on', !!on); }
    function setLabels() { if (!cur) return; lblH.textContent = cur.w + ' cm'; lblV.textContent = cur.h + ' cm'; }
    function drawDims() {
      if (!cur || !layer.classList.contains('ecr-dims-on')) return;
      var W = cur.w / 100, H = cur.h / 100, p = art.position, z = p.z + cur.d / 200, o = 0.075, tk = 6;
      var a = scr(p.x - W / 2, p.y + H / 2 + o, z), b = scr(p.x + W / 2, p.y + H / 2 + o, z);
      var c = scr(p.x + W / 2 + o, p.y - H / 2, z), e = scr(p.x + W / 2 + o, p.y + H / 2, z);
      dimH.setAttribute('d', 'M' + a[0] + ' ' + a[1] + 'H' + b[0] + 'M' + a[0] + ' ' + (a[1] - tk / 2) + 'v' + tk + 'M' + b[0] + ' ' + (b[1] - tk / 2) + 'v' + tk);
      dimV.setAttribute('d', 'M' + c[0] + ' ' + c[1] + 'V' + e[1] + 'M' + (c[0] - tk / 2) + ' ' + c[1] + 'h' + tk + 'M' + (e[0] - tk / 2) + ' ' + e[1] + 'h' + tk);
      lblH.style.transform = 'translate(' + ((a[0] + b[0]) / 2) + 'px,' + (a[1] - 6) + 'px) translate(-50%,-100%)';
      lblV.style.transform = 'translate(' + (c[0] + 7) + 'px,' + ((c[1] + e[1]) / 2) + 'px) translate(0,-50%)';
    }
    function setRef(i) {
      if (i < 0) { layer.classList.remove('ecr-ref-on'); return; }
      refEl.textContent = (i === 4 && ROOMS[4].benchHidden) ? 'Schutting · 230 cm hoog' : REFS[i];
    }

    // ---------- tekenen
    function easeIO(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
    var STUDIO_TURN = -0.34;
    function turn(c, ry) {
      var k = ry / STUDIO_TURN;
      art.rotation.set(0.04 * k, ry, 0);
      art.position.z = c.pos.z + Math.abs(Math.sin(ry)) * c.w / 200 * 1.05;
    }
    function lerpCam(a, b, e) { cam.x = a.x + (b.x - a.x) * e; cam.y = a.y + (b.y - a.y) * e; cam.z = a.z + (b.z - a.z) * e; cam.ty = a.ty + (b.ty - a.ty) * e; }
    var mx = 0, my = 0, smx = 0, smy = 0, t0 = performance.now(), lastMove = performance.now();
    function frame(now) {
      raf = null;
      var leaving = anim && anim.type === 'outro';
      if ((!api.active && !leaving) || !visible || document.hidden) return;
      if (opts.getImage) loadImage(opts.getImage());
      checkGeometry();
      // tuin: bank zacht weg als het canvas zo laag hangt dat het erachter zou verdwijnen
      var tr = ROOMS[4];
      if (tr.bench) {
        var rf = anim && anim.to ? anim.to : cur, tg = 1;
        tg = 0; // bank altijd weg in de tuin
        tr.benchHidden = tg === 0;
        tr.benchOp = tr.benchOp == null ? tg : tr.benchOp + (tg - tr.benchOp) * 0.12;
        if (Math.abs(tr.benchOp - tg) < 0.01) tr.benchOp = tg;
        var bo = tr.benchOp, btr = bo < 0.99;
        if (tr.benchMat.transparent !== btr) { tr.benchMat.transparent = btr; tr.benchMat.needsUpdate = true; }
        tr.benchMat.opacity = bo; tr.benchMat.depthWrite = bo > 0.5;
        tr.bench.visible = bo > 0.02;
        if (bo > 0 && bo < 1) kick();
      }
      if (anim) {
        var p = Math.min(1, (now - anim.t0) / anim.dur), e = easeIO(p), c = anim.to;
        if (anim.type === 'intro') {
          // rustig uitzoomen tot de hele kamer in beeld is
          lerpCam(anim.from, c.cam, anim.soft ? easeOut(p) : easeIO(p));
          // het canvas staat eerst schuin, net als in de studio, en draait dan naar de muur
          if (anim.rot) turn(c, anim.rot * (1 - easeIO(Math.min(1, p * 1.5))));
        } else if (anim.type === 'outro') {
          lerpCam(anim.from, anim.target, easeIO(p));
          if (anim.rot) turn(c, anim.rot * easeIO(p));
        } else if (anim.type === 'move') {
          var a = anim.fromPos, b = c.pos, arc = Math.sin(Math.PI * e);
          // het canvas schuift vlak langs de muur mee, met zijn schaduw er strak achter
          art.position.set(a.x + (b.x - a.x) * e, a.y + (b.y - a.y) * e, a.z + (b.z - a.z) * e);
          art.rotation.set(0, 0, 0);
          blob.position.set(art.position.x + 0.035, art.position.y - 0.05, 0.004);
          lerpCam(anim.fromCam, c.cam, e);
          cam.z += arc * 0.35;
        } else if (anim.type === 'flip') {
          var hf = anim.dur / 2, el = now - anim.t0, f, ry, bw, bh;
          if (!anim.swapped) {
            var k1 = Math.min(1, el / hf), e1 = k1 * k1 * (3 - 2 * k1);
            ry = e1 * Math.PI / 2; f = e1 * 0.5; bw = anim.fromW; bh = anim.fromH; p = 0;
            // wacht op het edge-on punt tot de nieuwe uitsnede klaar is (max. 0,7 s extra)
            if (k1 >= 1 && (texUrl !== anim.tex0 || el > hf + 700)) { anim.swapped = true; anim.t1 = now; buildMesh(c.w, c.h, c.d); art.scale.set(1, 1, 1); }
          } else {
            var k2 = Math.min(1, (now - anim.t1) / hf), e2 = 1 - Math.pow(1 - k2, 3);
            ry = -(1 - e2) * Math.PI / 2; f = 0.5 + e2 * 0.5; bw = c.w; bh = c.h; p = k2;
          }
          art.rotation.set(0, ry, 0);
          art.position.lerpVectors(anim.fromPos, c.pos, f);
          // tijdens het omdraaien naar voren schuiven, zodat de helft van het canvas niet door de muur gaat
          art.position.z += Math.abs(Math.sin(ry)) * (bw / 200 + 0.015);
          lerpCam(anim.fromCam, c.cam, f);
          blob.position.set(art.position.x + 0.035, art.position.y - 0.05, 0.004);
          blob.scale.set((bw / 100 * 1.32) * Math.max(0.08, Math.abs(Math.cos(ry))) + 0.12, bh / 100 * 1.32 + 0.12, 1);
        } else if (anim.type === 'fade') {
          var OUT = 380, IN = 560, el2 = now - anim.t0;
          if (!anim.swapped && !anim.go) {
            // eerst de nieuwe uitsnede laten klaarmaken terwijl het canvas gewoon blijft staan; zo valt het rekenwerk niet midden in de vervaging
            p = 0;
            if (texUrl !== anim.tex0 || el2 > (anim.maxWait || 1200)) anim.go = now;
          }
          if (!anim.swapped && anim.go) {
            el2 = now - anim.go;
            var q1 = Math.min(1, el2 / OUT);
            setArtOpacity(1 - q1 * q1 * (3 - 2 * q1)); p = 0;
            lerpCam(anim.fromCam, c.cam, 0.45 * easeIO(q1));
            // wacht kort op de nieuwe uitsnede (max. 0,9 s extra), dan pas opbouwen
            if (q1 >= 1) {
              anim.swapped = true; anim.t1 = now;
              buildMesh(c.w, c.h, c.d); setArtOpacity(0);
              // hero: meerdelige vorm verschijnt als één geheel en splitst zich daarna rustig in panelen
              if (opts.splitIn) { var tr0 = opts.getTri ? opts.getTri() : null; if (tr0 && mesh && mesh.children && mesh.children.length > 1) { var fx = tr0.pw / (tr0.pw + tr0.gap), fy = (tr0.ph || 1) / ((tr0.ph || 1) + tr0.gap); anim.split = mesh.children.map(function (o) { var s = { o: o, x1: o.position.x, y1: o.position.y, x0: o.position.x * fx, y0: o.position.y * fy }; o.position.x = s.x0; o.position.y = s.y0; return s; }); } }
              art.scale.set(1, 1, 1); art.rotation.set(0, 0, 0); art.position.copy(c.pos);
              blob.position.set(c.pos.x + 0.035, c.pos.y - 0.05, 0.004);
              blob.scale.set(c.w / 100 * 1.32 + 0.12, c.h / 100 * 1.32 + 0.12, 1);
            }
          } else if (anim.swapped) {
            var q2 = Math.min(1, (now - anim.t1) / IN);
            setArtOpacity(1 - Math.pow(1 - q2, 3)); p = q2;
            lerpCam(anim.fromCam, c.cam, 0.45 + 0.55 * easeIO(q2));
            if (anim.split) {
              var sq3 = Math.min(1, Math.max(0, (now - anim.t1 - 320) / 900)), se = sq3 < 0.5 ? 4 * sq3 * sq3 * sq3 : 1 - Math.pow(-2 * sq3 + 2, 3) / 2;
              anim.split.forEach(function (s) { s.o.position.x = s.x0 + (s.x1 - s.x0) * se; s.o.position.y = s.y0 + (s.y1 - s.y0) * se; });
              p = Math.min(q2, sq3);
            }
          }
        } else if (anim.type === 'resize') {
          var fs = anim.fromScale;
          art.scale.set(fs.x + (1 - fs.x) * e, fs.y + (1 - fs.y) * e, fs.z + (1 - fs.z) * e);
          art.position.lerpVectors(anim.fromPos, c.pos, e);
          lerpCam(anim.fromCam, c.cam, e);
          blob.position.set(art.position.x + 0.035, art.position.y - 0.05, 0.004);
          blob.scale.set(c.w / 100 * art.scale.x * 1.32 + 0.12, c.h / 100 * art.scale.y * 1.32 + 0.12, 1);
        }
        if (anim.type === 'slide') {
          var sDx = anim.dx;
          if (p < 0.5) {
            // ease 0 = doorlopend (carrousel draait), 1 = rustig vertrekken en landen
            var sq = p * 2, sk = sq + (sq * sq - sq) * anim.ease;
            art.position.x = anim.fromPos.x - sDx * sk; setArtOpacity(1 - sk * 0.9);
          } else {
            if (!anim.swapped) { anim.swapped = true; buildMesh(c.w, c.h, c.d); art.scale.set(1, 1, 1); art.rotation.set(0, 0, 0); art.position.copy(c.pos); setBlob(c); }
            var sq2 = (p - 0.5) * 2, sk2 = sq2 + (1 - Math.pow(1 - sq2, 3) - sq2) * anim.ease;
            art.position.x = c.pos.x + sDx * (1 - sk2); setArtOpacity(0.1 + 0.9 * sk2);
          }
          blob.position.set(art.position.x + 0.035, art.position.y - 0.05, 0.004);
        }
        if (p >= 1) { var done = anim; anim = null; if (done.type !== 'outro') land(done.to); }
      } else if (cur) {
        var s = (now - settleT) / 1000;
        if (s > 0.15) { setDims(true); layer.classList.add('ecr-ref-on'); }
      }
      // rustige camera met een beetje diepte als je de muis beweegt
      var t = (now - t0) / 1000;
      smx += (mx - smx) * 0.05; smy += (my - smy) * 0.05;
      var idle = reduce ? 0 : Math.sin(t * 0.22) * 0.05;
      camera.position.set(cam.x + smx * 0.2 + idle, cam.y - smy * 0.08, cam.z);
      camera.lookAt(cam.x + smx * 0.05, cam.ty, 0);
      for (var i = 0; i < patches.length; i++) patches[i].position.x = -2.05 + Math.sin(t * 0.08 + i * 1.7) * 0.2;
      // schuin canvas (draaien vanuit/naar 3D, liggend/staand): geen lange slagschaduw op de muur, de zachte schaduw eronder blijft
      if (mesh) { var csh = Math.abs(art.rotation.y) < 0.03 && artOp > 0.6; mesh.traverse(function (o) { if (o.isMesh) o.castShadow = csh; }); }
      renderer.render(scene, camera);
      drawDims();
      schedule();
    }
    function schedule() { if (!raf && (api.active || (anim && anim.type === 'outro')) && visible && !document.hidden && renderer) raf = requestAnimationFrame(frame); }
    function kick() { schedule(); }
    function setActive(on) {
      // intro die al klaarstond (eerste kamerbezoek) start pas echt als de kamer zichtbaar wordt
      if (on && !api.active && anim && anim.type === 'intro') anim.t0 = performance.now();
      api.active = !!on;
      layer.classList.toggle('ecr-on', !!on);
      if (on) {
        if (opts.getImage) loadImage(opts.getImage());
        resize();
        if (cur && (!anim || anim.type === 'outro')) {
          // vanuit de 3D-studio: begin vlak bij het canvas en zoom uit naar de kamer
          copyCam(cam, closeCam(cur)); setDims(false); layer.classList.remove('ecr-ref-on');
          anim = { type: 'intro', t0: performance.now(), dur: reduce ? 1 : 1700, from: Object.assign({}, cam), to: cur, rot: 0 };
          turn(cur, anim.rot);
        }
        schedule();
      } else if (cur && !reduce && (!anim || anim.type === 'intro')) {
        // terug naar de studio: camera duikt naar het canvas terwijl de kamer vervaagt
        setDims(false); layer.classList.remove('ecr-ref-on');
        anim = { type: 'outro', t0: performance.now(), dur: 1250, from: Object.assign({}, cam), target: closeCam(cur), to: cur, rot: 0 };
        schedule();
      }
    }
    // three.js wordt al door de 3D-preview geladen; even wachten als hij er nog niet is
    var tries = 0;
    (function wait() {
      if (window.THREE) return build();
      if (++tries < 150) setTimeout(wait, 100);
    })();
    return api;
  }

  window.ElaramoRooms = { mount: mount, names: NAMES };
})();
